<template>
  <body v-if="!router.currentRoute.value.params.token" class="d-flex justify-content-center align-items-center vh-100 bg-light" style="flex-direction: column;">
    <img src="../assets/logo2.png" style="cursor:pointer" @click="router.push('/')">
    <div class="card shadow p-4" style="width: 350px;">
      <h2 class="text-center mb-3">Reset Password</h2>
      <form method="POST">
        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input v-model="email" type="text" id="email" name="email" class="form-control" required>
        </div>
        <button @click="reset" type="button" class="btn btn-success w-100">Reset</button>
      </form>
    </div>
  </body>
  <body v-else class="d-flex justify-content-center align-items-center vh-100 bg-light" style="flex-direction: column;">
    <img src="../assets/logo2.png" style="cursor:pointer" @click="router.push('/')">
    <div class="card shadow p-4" style="width: 350px;">
      <h2 class="text-center mb-3">Reset Password</h2>
      <form method="POST">
        <div class="mb-3">
          <label for="password1" class="form-label">Nuova password</label>
          <input v-model="password1" type="password" id="password1" name="password1" class="form-control" required>
          <label for="password2" class="form-label">Ripeti nuova password</label>
          <input v-model="password2" type="password" id="password2" name="password2" class="form-control" required>
        </div>
        <button @click="setPassword" type="button" class="btn btn-success w-100">Reset</button>
      </form>
    </div>
  </body>
</template>

<script>
import { ref } from 'vue';
import loginMethods from "../api/resources/loginMethods"
import router from '../router/index.js'
export default {
  name: 'ResetPasswordView',
  emits: ['alert'],
  setup(_, { emit }) {
    const email = ref(null);
    const password1 = ref(null);
    const password2 = ref(null);

    console.log(router.currentRoute.value.params.token)
    async function reset() {
        let obj = {
            email:email.value
        }
        let res = await loginMethods.createResetToken(obj);
        if(res){
            emit('alert', { message: "Email reset inviata!", color: "green" });
            router.push("/login");
        }
        else{
            emit('alert', { message: "Errore", color: "red" });
        }
    }

    async function setPassword(){
        if(!password1.value || password1.value != password2.value){
            emit('alert', { message: "Le password non corrispondono", color: "red" });
            return;
        }
        if(password1.value.length < 8){
          emit('alert', { message: "La password deve contenere almeno 8 caratteri", color: "red" });
          return;
        }
        else{
            let obj = {
                resetToken:router.currentRoute.value.params.token,
                password:password1.value
            }
            let res = await loginMethods.resetPassword(obj);
            if(res){
                emit('alert', { message: "Password reimpostata", color: "green" });
                router.push("/login");
            }
            else{
                emit('alert', { message: "Errore", color: "red" });
            }
        }
    }


    return {
      email,reset,router,setPassword,password1,password2
    }
  }
}
</script>